import React from 'react';
import { Field, reduxForm } from 'redux-form/immutable';
import RenderSelectField from "../inputs/renderSelectField";
import MenuItem from "@material-ui/core/MenuItem";

const SortCriteriaForm =  (props) => {
  return (
    <form>
      <div className={'form-row'}>
        <div className={'form-group col-7'}>
          <Field name="sortBy" label={'Sort By'} component={RenderSelectField} fullWidth>
            <MenuItem value={'id'} >{'Id'}</MenuItem>
            <MenuItem value={'code'} >{'Code'}</MenuItem>
            <MenuItem value={'name'} >{'Name'}</MenuItem>
            <MenuItem value={'weightOld'} >{'Εξάμηνη βαρύτητα'}</MenuItem>
            <MenuItem value={'weightNew'} >{'Βαρύτητα νέων καταστημάτων'}</MenuItem>
            <MenuItem value={'weightNewComing'} >{'Βαρύτητα υφιστάμενων καταστημάτων'}</MenuItem>
            <MenuItem value={'category'} >{'Category'}</MenuItem>
            <MenuItem value={'department'} >{'Department'}</MenuItem>
            <MenuItem value={'createdDate'} >{'Created Date'}</MenuItem>
          </Field>
        </div>
        <div className={'form-group col-5'}>
          <Field name={'sortOrder'} label={'Sort order'} component={RenderSelectField} fullWidth>
            <MenuItem value={'asc'}>{'ASC'}</MenuItem>
            <MenuItem value={'desc'}>{'DESC'}</MenuItem>
          </Field>
        </div>
      </div>
    </form>
  )

};

export default reduxForm({
  enableReinitialize: true,
  form: 'sortCriteriaForm',
})(SortCriteriaForm);



// WEBPACK FOOTER //
// ./src/components/criteria/sortCriteriaForm.js